module.exports = __webpack_public_path__ + "img/UZ.146a1b0c.svg";